import { api } from "@api/api";
import { UseFetchResourcesByIdsParams } from "./types";

export async function fetchResourcesByIdsService<T>({ resource, ids }: UseFetchResourcesByIdsParams): Promise<T> {
  if (!ids.length) return {} as T;

  try {
    const { data } = await api.get<T>(`/${resource}/`, {
      params: { ids: ids.join(",") },
    });
    return data;
  } catch (error) {
    console.error("Error fetching by IDs:", error);
    throw error;
  }
}
